import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapValueList = (item) => {
  return {
    key: uuidv4(),
    id: item?.value_list_id,
    name: item?.value_list_name,
    description: item?.value_list_description,
    type_id: item?.value_list_type_id,
  }
}

export const getValueListApi = (id) => {
  const config = {
    method: 'get',
    url: id ? `/api/v1/value_list/?value_list_type_id=${id}` : `/api/v1/value_list/`,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data?.items, mapValueList) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getValueListTypeApi = () => {
  const config = {
    method: 'get',
    url: `/api/v1/value_list/type`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data?.items })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getValueListByTypeCodeApi = (code) => {
  const config = {
    method: 'get',
    url: `/api/v1/value_list/type/${code}`,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}
